import { config } from "../config";
import Call from "../utils/Call";
import storage from "../utils/Storage";

class Enroll extends Call {
    constructor() {
        super(config.ENROLL_HOST);
    }

    header() {
        return {
            "Content-Type": "application/json",
            Authorization: `Bearer ${config.JWT_SECRET}`,
        };
    }

    async login(data) {
        try {
            return await this.call("post", `/auth/login`, { data });
        } catch (err) {
            return false;
        }
    }

    async logout() {
        try {
            return await this.call("get", `/auth/logout`, {});
        } catch (err) {
            return false;
        }
    }

    async create(data) {
        try {
            return await this.call("post", `/users`, { data });
        } catch (err) {
            return err;
        }
    }

    async getUsers() {
        try {
            return await this.call("get", `/users`, {});
        } catch (err) {
            return false;
        }
    }

    async deleteUser(id) {
        try {
            return await this.call("delete", `/users/${id}`, {});
        } catch (err) {
            return err;
        }
    }

    async getInvites(invites) {
        try {
            return invites;
        } catch (err) {
            return false;
        }
    }
}

export default new Enroll();
